module.exports = __webpack_public_path__ + "img/paso2.f55a4c40.png";